import { lazy } from "react"
import {
  QUEENS_LIST_VIEW,
  APIARY_HIVE_QUEEN_VIEW,
  EDIT_QUEEN_VIEW,
  NEW_QUEEN_FOR_HIVE_VIEW,
  NEW_QUEEN_VIEW,
  QUEEN_VIEW,
} from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllQueensView = lazy(
  () =>
    import("@/features/bees/views/queens/all-queens-view/all-queens-view.tsx"),
)
const EditQueenView = lazy(
  () =>
    import("@/features/bees/views/queens/edit-queen-view/edit-queen-view.tsx"),
)
const NewQueenView = lazy(
  () =>
    import("@/features/bees/views/queens/new-queen-view/new-queen-view.tsx"),
)
const QueenView = lazy(
  () => import("@/features/bees/views/queens/queen-view/queen-view.tsx"),
)

export const queensRoutes = [
  {
    path: QUEENS_LIST_VIEW,
    element: <AllQueensView />,
  },
  {
    path: NEW_QUEEN_FOR_HIVE_VIEW,
    element: <NewQueenView />,
  },
  {
    path: NEW_QUEEN_VIEW,
    element: <NewQueenView />,
  },
  {
    path: QUEEN_VIEW,
    element: <QueenView />,
  },
  {
    path: APIARY_HIVE_QUEEN_VIEW,
    element: <QueenView />,
  },
  {
    path: EDIT_QUEEN_VIEW,
    element: <EditQueenView />,
  },
  {
    path: NEW_QUEEN_FOR_HIVE_VIEW,
    element: <NewQueenView />,
  },
]

const DESKTOP_QUEENS_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: queensRoutes,
  },
]

const MOBILE_QUEENS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: queensRoutes,
  },
]

export const getQueensRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_QUEENS_ROUTES : MOBILE_QUEENS_ROUTES
}
